import { atom } from 'jotai';

export const NO_CATEGORY_FILTER_KEY = '__no_category__';

export const productCategoryFilterState = atom<string[]>([]);
